var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.props.sortable)?_c('vtx-icon',{staticClass:"vcr-datatable__sort-icon",attrs:{"name":_vm.icon}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }